module.exports = __webpack_public_path__ + "static/media/image3.365d96f0.jpg";